import $ from 'jquery';
import btmq from './Plugins/BootstrapMediaQuery';
import ifExists from './Plugins/ifExists';


$(function () {
	// Document ready
    
    /**
     * Set background images according to screen size
     */
    var $window = $(window);
    var $srcSets = $('.srcSet');

    $srcSets.each(function() {
        var $currImg = $(this);
        var img = $currImg.get(0);
        var src = img.currentSrc ? img.currentSrc : img.src;
        $currImg.closest('.bgFromSrcSet').css('background-image', "url('" + src + "')").animate({
            opacity: 1
        }, {
            duration: 1000
        });
        $srcSets = $srcSets.not($currImg);
        //$currImg.remove();
    });    
    
     //$('form').attr('action','https://payroll.voorbeeld.io/offerte-aanvraag/#gf_1');
    
    
});
